import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getUserServicesApi } from '../services/meliAccountServices'

const STORAGE_KEY = (meliUserId) => `mlpro-services-${meliUserId}`

const loadFromStorage = (meliUserId) => {
  if (!meliUserId) return []
  try {
    const raw = localStorage.getItem(STORAGE_KEY(meliUserId))
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

const getUserId = (state) => {
  const id = state.auth?.userData?.id
  if (id) return id
  try {
    const token = localStorage.getItem('access_token')
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.sub || payload.id || payload.user_id || null
    }
  } catch (e) {}
  return null
}

export const fetchUserServices = createAsyncThunk(
  'meliUserServices/fetch',
  async (meliUserId, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const userId = getUserId(state)

      if (!userId || !meliUserId) {
        return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      }

      const data = await getUserServicesApi({ userId, meliUserId })
      const services = Array.isArray(data) ? data : (data.services || [])

      try {
        localStorage.setItem(STORAGE_KEY(meliUserId), JSON.stringify(services))
      } catch (e) {}

      return { meliUserId, services }
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || 'Error al cargar servicios')
    }
  }
)

const meliUserServicesSlice = createSlice({
  name: 'meliUserServices',
  initialState: {
    services: [],
    meliUserId: null,
    loading: false,
    error: null
  },
  reducers: {
    hydrateFromStorage: (state, action) => {
      const meliUserId = action.payload
      state.meliUserId = meliUserId
      state.services = loadFromStorage(meliUserId)
    },
    clearUserServices: (state) => {
      state.services = []
      state.meliUserId = null
      state.loading = false
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserServices.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUserServices.fulfilled, (state, action) => {
        state.loading = false
        state.services = action.payload.services
        state.meliUserId = action.payload.meliUserId
      })
      .addCase(fetchUserServices.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error desconocido'
      })
  }
})

export const { hydrateFromStorage, clearUserServices } = meliUserServicesSlice.actions

// Selectors
export const selectUserServices     = (state) => state.meliUserServices.services
export const selectUserServicesLoading = (state) => state.meliUserServices.loading

export const selectServiceStatus = (serviceType) => (state) => {
  const svc = state.meliUserServices.services.find(s => s.serviceType === serviceType)
  return svc?.status || null
}

export default meliUserServicesSlice.reducer
